import { OrderStatus } from '@/models/types/OrderStatus';
import { ContactPerson } from '@/models/types/ContactPerson';
import { OrderChanges } from '@/models/OrderChanges';
import { OrderDetail } from '@/models/OrderDetail';
import { Address } from '@/models/types/Address';
import { Type } from 'class-transformer';
import {
  OrderAppointment,
  OrderArticles,
  OrderInstallerAppointment,
  OrderServiceGroup,
} from '@/models/types/Order';
import 'reflect-metadata';
import { Compatibility } from '@/models/Compatibility';
import { smartHeatingCustomizedNumbers } from '@/enums/articleNumberMapping';

export const DMGW6_ARTICLE_REFERENCE = '35460';

export class Order {
  public id: string;
  public orderId: string;
  public businessEntityId: string;
  public billingUnitReference: string;
  public workTypeCode?: OrderType;
  public locationReference?: string;
  public propertyId: string;
  public appointment: OrderAppointment;
  public installerAppointment?: OrderInstallerAppointment;
  public articles?: OrderArticles;
  public serviceGroups?: Array<OrderServiceGroup>;
  public notes?: string;
  public contactPerson?: ContactPerson;
  public description?: string;
  public roomGroupAppointments?: Array<string>;
  public status: OrderStatus;
  @Type(() => OrderChanges)
  public changes?: OrderChanges;
  public primaryAddress: Address;
  public additionalAddresses?: Array<Address>;
  @Type(() => Compatibility)
  public propertyCompatibility?: Compatibility;
  public installerId: string;
  @Type(() => OrderDetail)
  public detail?: OrderDetail;
  public modifiedAt?: string;
  public isEditable?: boolean;

  constructor() {
    this.id = '';
    this.orderId = '';
    this.businessEntityId = '';
    this.billingUnitReference = '';
    this.workTypeCode = undefined;
    this.locationReference = '';
    this.propertyId = '';
    this.appointment = {
      start: '',
      end: '',
    };
    this.installerAppointment = undefined;
    this.description = '';
    this.articles = {
      items: [],
      note: undefined,
    };
    this.serviceGroups = undefined;
    this.roomGroupAppointments = [];
    this.status = OrderStatus.OPEN;
    this.contactPerson = undefined;
    this.notes = '';
    this.primaryAddress = new Address();
    this.additionalAddresses = [];
    this.changes = new OrderChanges();
    this.propertyCompatibility = new Compatibility();
    this.installerId = '';
    this.detail = new OrderDetail();
    this.modifiedAt = '';
    this.isEditable = true;
  }

  hasSmartHeatingDevices() {
    return this.articles?.items.some((item) => {
      if (!item.articleReference) return false;
      return smartHeatingCustomizedNumbers.includes(item.articleReference);
    });
  }

  hasDmgw6Article() {
    return (
      this.articles?.items.some(
        (item) => item.articleReference === DMGW6_ARTICLE_REFERENCE
      ) ?? false
    );
  }
}

export enum OrderType {
  ON_SITE_INSPECTION = 'BE',
  TKD = 'TKD',
  MONT = 'MONT',
}
